const FILENAME_STAR_PATTERN = /filename\*=(?:UTF-8|UTF8)''([^;]+)/i;
const FILENAME_PATTERN = /filename="?([^";]+)"?/i;

export function extractFilename(contentDisposition: string | undefined, fallback: string): string {
	if (!contentDisposition) {
		return fallback;
	}

	const starMatch = FILENAME_STAR_PATTERN.exec(contentDisposition);
	if (starMatch) {
		try {
			return decodeURIComponent(starMatch[1].trim());
		} catch {
			// Malformed percent-encoding in filename* - fall through to the plain filename param.
		}
	}

	const match = FILENAME_PATTERN.exec(contentDisposition);
	return match ? match[1].trim() : fallback;
}
